/**
 * Convert hex color to rgba with opacity for light backgrounds
 * Content-specific utility for styling platform cards and variations
 */
export function hexToRgba(hex: string, opacity: number = 0.1): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

